<template>
  <div class="returnAdd">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('claimForCredit.collapseTitle.baseTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <base-form @setTableData="setTableData" ref="baseForm" :type="$route.query.type" />
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre"> <span></span>认领信息 </div>
        </template>
        <div class="collapse-content">
          <goods-table ref="goodsTable" />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <!-- 修改 -->
      <el-button
        type="primary"
        @click="edit()"
        :loading="load"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042916303188828']"
        >{{ this.$t('applicationDetail.btnList.edit') }}</el-button
      >
      <!-- 保存 -->
      <el-button
        type="primary"
        @click="save('002')"
        :loading="load"
        :disabled="$route.query.returnStatus != 2"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042916305203489']"
        >{{ this.$t('claimForCredit.btnList.save') }}</el-button
      >
      <!-- 确认认领 -->
      <el-button
        type="primary"
        @click="save('003')"
        :loading="load"
        :disabled="$route.query.returnStatus != 2"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042916333364036']"
        >{{ this.$t('claimForCredit.btnList.submit') }}</el-button
      >
      <!-- 撤销 -->
      <el-button
        type="primary"
        @click="revokeReceiveCreditLetter"
        :disabled="$route.query.returnStatus != 2"
        :loading="load"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042916345891745']"
        >{{ this.$t('functionBtn.revert') }}</el-button
      >
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import BaseForm from '../detailOrAcceptCredit/components/baseForm'; // 基本信息
  import GoodsTable from '../detailOrAcceptCredit/components/goodsTable'; // 基本信息
  import API from '@/api/capitalCenter/letterOfCredit';
  // import { resolve, reject } from 'q';

  export default {
    name: 'claimForCreditLC',
    components: {
      BaseForm,
      GoodsTable,
    },
    data() {
      return {
        load: false,
        activeNames: ['1', '2'],
        componentsList: ['baseForm', 'goodsTable'],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    mounted() {},
    methods: {
      // 点击修改/显示
      edit() {
        this.$route.query.returnStatus = this.$route.query.returnStatus == '2' ? '4' : '2';
      },
      save(btnType) {
        if (this.$refs.goodsTable.calculateIssuingAmount > this.$refs.baseForm.baseData.clAmount) {
          this.$message({
            showClose: true,
            message: this.$t('claimForCredit.msg.amountTip'),
            type: 'error',
          });
          return;
        }
        // if (this.$refs.goodsTable.calculateIssuingAmount != this.$refs.baseForm.baseData.clAmount) {
        //   this.$message({
        //     showClose: true,
        //     message: this.$t('claimForCredit.msg.notClaim'),
        //     type: 'error',
        //   });
        //   return;
        // }
        this.$refs.goodsTable.$refs.goodsTable.validate().then(() => {
          // if (valid) {
          let params = {
            id: this.$refs.baseForm.baseData.id,
            sourceType: this.$refs.baseForm.baseData.sourceType,
            contractList: this.$refs.goodsTable.$refs.goodsTable.getTableData().fullData,
            delContractList: this.$refs.goodsTable.delContractList,
            statusFlag: btnType,
          };
          this.saveData(btnType, params);
          // }
        });
      },
      saveData(btnType, params) {
        this.loading.startLoading();
        // return console.log('请求接口',API.OPERA_CREDITLETTER);
        // 保存提交
        this.$axios.post(API.OPERA_CREDITLETTER, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message:
                btnType == '002'
                  ? this.$t('claimForCredit.msg.saveSussess')
                  : this.$t('claimForCredit.msg.submitSusscess'),
              type: 'success',
            });
            if (btnType == '002') {
              this.$refs.baseForm.getDetail(this.$route.query.id);
            } else {
              this.goNewPage();
            }
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },

      revokeReceiveCreditLetter() {
        this.$confirmAction('撤销数据？', '是否确认撤销').then(() => {
          this.loading.startLoading();
          let id = this.$refs.baseForm.baseData.id;
          this.$axios.post(API.REVOKE_RECIVE_CREDITLETTER, { id: id }).then((res) => {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.goNewPage();
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        });
      },
      setTableData(baseData) {
        this.$refs.goodsTable.goodsData = baseData.contractList;
        this.$refs.goodsTable.$refs.goodsTable.loadData(baseData.contractList);
      },

      goNewPage() {
        let path = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: true,
              title: '信用证收证认领',
            },
          },
          toPath: {
            path: '/letterOfCredit/searchReceiveCredit',
            name: 'searchReceiveCreditLC',
            meta: {
              keepAlive: false,
              title: '信用证收证查询',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
  };
</script>
